import { render, staticRenderFns } from "./ProjectDetailMemberTab.vue?vue&type=template&id=48cb664d&scoped=true&"
import script from "./ProjectDetailMemberTab.vue?vue&type=script&lang=js&"
export * from "./ProjectDetailMemberTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48cb664d",
  null
  
)

export default component.exports